import type { TableView } from 'owa-mail-list-store';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "SenderScreening" */ './lazyIndex'),
    { name: 'SenderScreening' }
);

export const LazySenderScreening: LazyComponent<
    {
        tableView: TableView;
    },
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.SenderScreening);
